<div class="white container-fluid">
  <div class="lock-screen">
    <div class="animate fadeIn text-center">
      <div class="row p-0">
        <div id="bgImage" class="col-md-9 blue-seprator">
          <img src="assets/images/RCM_1.jpg" class="img-fluid">
        </div>
        <div class="col-md-3">
          <div id="enableTwoFactor">
            <ng-container *ngIf="activeUser && activeUser.enableTFAuth">
              <!-- <div *ngIf="activeUser.enableTFAuth.status=='incomplete'">
                <h4 style="margin-top: 1rem !important;font-size: 1.8rem !important;">
                  Scan this barcode with your app.
                </h4>
                <h6>
                  Scan the image below with the two-factor authentication app on your phone.
                </h6>
              </div> -->
              <div class="alignBarcode"
                *ngIf="activeUser.enableTFAuth.enable==true && activeUser.enableTFAuth.status=='incomplete'">
                <!-- <span [innerHTML]="barCodeURI"></span> -->
                <div>
                  <h4>
                    Enter the six-digit code from the application
                  </h4>
                  <h6>
                    After scanning the barcode image, the app will display a six-digit code that you can enter below.
                  </h6>
                  <a href="https://support.google.com/accounts/answer/1066447?hl=en&ref_topic=2954345" target="_blank">
                    Download Google authenticator App
                  </a>
                </div>
                <!-- <form (ngSubmit)="submit()">
                  <div class="form-group">
                    <label for="" style="font-weight: bold">Enter Passcode</label>
                    <input [(ngModel)]="passcode" class="form-control" (keyup.enter)="submit()" placeholder="eg. 512364"
                      type="number" name="" id="" [attr.maxLength]="6"
                      onkeydown="javascript: return event.keyCode == 69 || event.keyCode == 107 || event.keyCode == 109 || event.keyCode == 189 || event.keyCode == 190 ? false : true"
                      onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)"
                      (keyup)="keyupPasscode($event)">
                  </div>
                  <div class="form-group">
                    <button type="submit">
                      Submit
                    </button>
                  </div>
                </form> -->
                <div class="form-group">
                  <label for="" style="font-weight: bold">Enter Passcode</label>
                  <input [(ngModel)]="passcode" class="form-control" placeholder="eg. 512364" type="number" name=""
                    id="" [attr.maxLength]="6"
                    onkeydown="javascript: return event.keyCode == 69 || event.keyCode == 107 || event.keyCode == 109 || event.keyCode == 189 || event.keyCode == 190 ? false : true"
                    onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)"
                    (keyup)="keyupPasscode($event)">
                </div>
                <div class="form-group">
                  <button class="btn btn-primary" (click)="submit()">
                    Submit
                  </button>
                </div>
              </div>

              <div *ngIf="activeUser.enableTFAuth.status=='incomplete'">
                <h4 style="margin-top: 1rem !important;font-size: 1.8rem !important;">
                  Scan this barcode with your app.
                </h4>
                <h6>
                  Scan the image below with the two-factor authentication app on your phone.
                </h6>
                <span [innerHTML]="barCodeURI"></span>
              </div>

            </ng-container>
            <ng-container *ngIf="activeUser && activeUser.enableTFAuth">
              <div class="alignBarcode"
                *ngIf="activeUser.enableTFAuth.enable==true && activeUser.enableTFAuth.status=='complete'">
                <!-- <span [innerHTML]="barCodeURI"></span> -->
                <div>
                  <h4>
                    Enter the six-digit code from the application
                  </h4>
                </div>
                <div class="form-group">
                  <label for="" style="font-weight: bold">Enter Passcode</label>
                  <input [(ngModel)]="passcode" class="form-control" placeholder="eg. 512364" type="number" name=""
                    id="" [attr.maxLength]="6"
                    onkeydown="javascript: return event.keyCode == 69 || event.keyCode == 107 || event.keyCode == 109 || event.keyCode == 189 || event.keyCode == 190 ? false : true"
                    onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)"
                    (keyup)="keyupPasscode($event)">
                </div>
                <div class="form-group">
                  <button class="btn btn-primary" (click)="submit()">
                    Submit
                  </button>
                </div>

                <span [innerHTML]="barCodeURI"></span>

              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>